import { CacheBusterContext } from 'src/context/CacheBusterContext';
import { IUser } from 'src/utils/interfaces/user';
import { useContext } from 'react';
import { useLocalization } from 'src/utils/useLocalization';
import { useSelector } from 'react-redux';
import './styles.scss';

const AppUpdateNotification = () => {
    const {
        isUpdateAvailable,
        refreshCacheAndReload,
        dismissUpdateNotification,
    } = useContext(CacheBusterContext);

    const brand: string = useSelector((state: IUser) => {
        const stateBrand = state.dealerDataInfo?.dealer.brand || 'vw';
        return stateBrand.toLowerCase();
    });
    const { appUpdateNotification } = useLocalization();

    if (!isUpdateAvailable) {
        return null;
    }

    return (
        <div
            aria-labelledby='app-update-toast-title'
            aria-live='polite'
            className='app-update-toast'
            role='dialog'
        >
            <h2 className='app-update-toast__title' id='app-update-toast-title'>
                {appUpdateNotification.LABEL_FIELD_APPNOTIFICATION_TITLE}
            </h2>

            <p className='app-update-toast__message'>
                {appUpdateNotification.LABEL_FIELD_APPNOTIFICATION_TEXT}
            </p>

            <div className='app-update-toast__actions'>
                <button
                    className='c-btn c-btn--secondary'
                    type='button'
                    onClick={dismissUpdateNotification}
                >
                    {appUpdateNotification.LABEL_FIELD_APPNOTIFICATION_AVOID}
                </button>

                <button
                    className={`c-btn c-btn--primary ${brand}`}
                    type='button'
                    onClick={() => void refreshCacheAndReload()}
                >
                    {appUpdateNotification.LABEL_FIELD_APPNOTIFICATION_RELOAD}
                </button>
            </div>
        </div>
    );
};

export default AppUpdateNotification;
